import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { ObjUtils } from '@/common/utils/ObjUtils';
import { useCallback } from 'react';

export const McdLedgerLineList = ({ mcdLedgerObj: mcdLedger }) => {
  const augRowsReq = useCallback(
    (rowsReq) => {
      if (!mcdLedger) return;

      rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('mcdLedgerId', mcdLedger.id));
    },
    [mcdLedger?.id],
  );

  const augTabButtons = (tabButtons) => {
    ObjUtils.clearObj(tabButtons); // Ledger Lines come from system only
  };

  const augFieldDefs = (fieldToFieldDef) => {
    // 1. Dimensions
    fieldToFieldDef.earnedPeriodId.precedence = 4;
    fieldToFieldDef.earnedPeriodId.hasName = false;

    fieldToFieldDef.prodId.precedence = 5;
    fieldToFieldDef.prodId.hasName = false;

    // 2. Statuses
    fieldToFieldDef.status.precedence = 1000;
    fieldToFieldDef.valStatus.precedence = 1001;

    // 3. Quantities
    fieldToFieldDef.rbtQty.precedence = 2000;
    fieldToFieldDef.openDispQty.precedence = 2001;
    fieldToFieldDef.calcDispQty.precedence = 2002;
    fieldToFieldDef.dueQty.precedence = 2003;
    fieldToFieldDef.paidQty.precedence = 2004;

    // 4. URAs
    fieldToFieldDef.latestStateInvUra.precedence = 3000;

    // 5. Amounts
    fieldToFieldDef.rbtAmt.precedence = 4001;
    fieldToFieldDef.dispAmt.precedence = 4003;
    fieldToFieldDef.dueAmt.precedence = 4004;
    fieldToFieldDef.paidAmt.precedence = 4005;
  };

  return (
    <EntityList
      entity="MCD_LEDGER_LINE"
      augRowsReq={augRowsReq}
      augTabButtons={augTabButtons}
      augFieldDefs={augFieldDefs}
    />
  );
};
